<template>
  <div class="gift-card-create-wrapper-right">
    <form data-vv-scope="giftCard">
      <div class="form-group">
        <label for="exampleInputEmail1"
															data-test="giftCardFormEmailHead"
															id="giftCardFormEmailHead">
          Email address
        </label>
        <input
          type="email"
          class="form-control"
          id="exampleInputEmail1"
          name="gift-card-email"
          aria-describedby="emailHelp"
          placeholder="Enter email"
          v-model="giftCardEmail"
          v-validate="'required|email'"
          :class="(showGiftCardError &&
          errors.has('giftCard.gift-card-email'))?'is-invalid':''"
										data-test="giftCardFormEmailInput"
        />
        <div
          class="invalid-feedback"
          v-if="(errors.has('giftCard.gift-card-email') && showGiftCardError)"
          id="gift-card-email-error"
										data-test="giftCardFormEmailInputError"
        >
          {{ errors.first('giftCard.gift-card-email') }}
        </div>
        <small
          id="emailHelp"
          class="form-text text-muted"
										data-test="giftCardFormEmailInfo"
        >
          We'll never share your email with anyone else.
        </small>
      </div>
      <div class="form-group">
        <label data-test="giftCardFormAmtHead"
															id="giftCardFormAmtHead">
          Amount
        </label>
        <integer-plusminus
          :min="min_amount"
          :step="increment_amount"
          :max="max_amount"
          v-model="giftCardPrice"
        >
        </integer-plusminus>
        <!--<input type="text"-->
        <!--class="form-control"-->
        <!--id="exampleInputPassword1"-->
        <!--name="gift-card-amount"-->
        <!--placeholder="Amount"-->
        <!--v-model="giftCardPrice"-->
        <!--@keyup="bindPrice()"-->
        <!--v-validate="'required|numeric'"-->
        <!--:class="(showGiftCardError &&-->
        <!--errors.has('giftCard.gift-card-amount'))?'is-invalid':''"-->
        <!--/>-->
        <!--<div class="invalid-feedback"-->
        <!--v-if="(errors.has('giftCard.gift-card-amount') && showGiftCardError)"-->
        <!--id="gift-card-amount-error"-->
        <!--&gt;-->
        <!--{{ errors.first('giftCard.gift-card-amount') }}-->
        <!--</div>-->
      </div>
      <button
        type="submit"
        class="btn btn-primary btn-type-primary"
        @click.prevent="action('giftCard')"
								data-test="giftCardFormSendBtn"
								id="giftCardFormSendBtn"
      >
        Send
      </button>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { IntegerPlusminus } from 'vue-integer-plusminus'

export default {
	name: 'gift-card-form',
	data () {
		return {
			showGiftCardError: false,
			giftCardEmail: '',
			giftCardPrice: 0,
			max_amount: 0,
			min_amount: 0,
			increment_amount: 0
		}
	},
	components: {
		IntegerPlusminus
	},
	watch: {
		giftCardPrice: {
			handler () {
				this.$emit('bindPrice', this.giftCardPrice)
			}
		}
	},
	computed: {
		...mapGetters('siteData', ['getGiftCardRules'])
	},
	beforeMount () {
		this.max_amount = this.getGiftCardRules.max_amount
		this.min_amount = this.getGiftCardRules.min_amount
		this.giftCardPrice = this.min_amount
		this.increment_amount = this.getGiftCardRules.increment_amount
	},
	methods: {
		// bindPrice() {
		//
		//   this.$emit('bindPrice', this.giftCardPrice);
		// },
		action (scope) {
			this.$validator.validateAll(scope)
				.then((result) => {
					if (result) {
						this.showGiftCardError = false
						const data = {
							email_id: this.giftCardEmail,
							quantity: 1,
							amount: this.giftCardPrice
						}

						this.$emit('giftCardData', data)
					} else {
						this.showGiftCardError = true
					}
				})
		}
	}
}
</script>

<style scoped>
</style>
